module.exports = __webpack_public_path__ + "img/funnel-vagdel-2021.e4d44b65.svg";